import React, {
  useRef,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import { AnimatePresence, motion } from "framer-motion";
import useMeasure from "react-use-measure";
import { _isometry } from "state/store.isometry";
import {
  active_project,
  current_language,
  isMulti_project_active,
  vis_showOldSlider,
} from "state/store.global";
import { iso_free } from "state/store.global";
import { iso_isrotating } from "state/store.global";
import { get, getFocus, setFocus, useAtom, useGet } from "state/jotai";
import {
  getIsoData,
  getLowIsoData,
  setIsoData,
} from "state/jotai.isometryDataHooks";
import { getProjectData } from "state/jotai.projectDataHooks";

import { useBreak } from "hooks/useBreak";

import { Cursor } from "./Isometry.Cursor";
import { Canvas } from "./Isometry.Canvas";
import { Center } from "./Isometry.Center";
import { Tiny } from "./Isometry.Tiny";
import { Svg } from "./Isometry.Svg";
import { Measure } from "./Isometry.Measure";
import { Recenter } from "./isometry.Recenter";
import { Loading2 } from "components/Loading2/Loading2";
import { ZoomPanPinch } from "components/ZoomPanPinch/ZoomPanPinch";
import { Compas } from "components/Compas/Compas";
import { NoSnapSlider } from "components/IsometryControls/NoSnapSlider";
import { Play } from "components/IsometryRotation/Play";
import { SnapOnRotationEnd } from "components/IsometrySnapOnRotationEnd/SnapOnRotationEnd";
import { _bootstrap } from "state/store.bootstrap";
import { ViewMap } from "pages/View.Map";
import { OverviewBack } from "./OverviewBack";
import { _project } from "state/store.projects";
import styled from "styled-components";
import { OldSnapSlider } from "components/OldIsometryControls/OldSnapSlider";
import { BREAK_ } from "constants";
import { DesktopColorLegend } from "components/ColorLegend/DesktopColorLegend";
import { Box } from "@mui/material";
import { STATICS } from "../../api/api";
import { useZppSetup } from "./Isometry.ZoomPanPinch";

import { isIframeMode } from "logging/logging";

import { Face } from "components/TopMenu/TopMenu";
import { useLocation } from "react-router-dom";

export const Isometry = () => {
  const timeoutRef = useRef(null);
  const [measure, bounds] = useMeasure();
  const [state, setState] = useState(false);
  const showOldSlider = useGet(vis_showOldSlider);

  const { pin, pid } = useGet(active_project);
  const projectType = getFocus(_bootstrap, "type");
  const statusIconPath = `${STATICS}/svg/statusicon.svg`;

  const lowIsoData = {
    frames: getLowIsoData("frames"),
    percent: getLowIsoData("percent"),
    status: getLowIsoData("status"),
    config: getLowIsoData("config"),
  };
 const isDesktop = useBreak("md_up");
  const frame = getIsoData("activeframe");
  const rawIndex = getIsoData("snapindex");

  const isoData = {
    tiny: getIsoData("tiny", "src"),
    frames: getIsoData("frames"),
    percent: getIsoData("percent"),
    status: getIsoData("status"),
    config: getIsoData("config"),
    frame,
    svg: getIsoData("overlays", frame),
    index: rawIndex,
  };
  const here = useLocation().pathname;
 const [currentLanguage] = useAtom(current_language);
  const raw = get(_project, "unitsraw", "Units");
  const units = getProjectData("units", "Units");
  const setIndex = setIsoData("snapindex");
  const setFrame = setIsoData("activeframe");
  const setScale = setFocus(_isometry, "activescale");
  const iFrameEnabled = isIframeMode();
  const zppRef = useRef();
  const canRef = useRef();
  const dropdownOptions = getFocus(_bootstrap, "projectnames");
  const dim = useMemo(
    () => ({
      W: lowIsoData.config?.IMAGE_W,
      H: lowIsoData.config?.IMAGE_H,
    }),
    [lowIsoData.config],
  );
  const point = lowIsoData.config?.CENTER;
  const zppsetup = useZppSetup(bounds, zppRef, dim, setScale, true, pin);
  const rmode = useGet(iso_free);
  const isrotate = useGet(iso_isrotating);
  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];
  const isMobile = useBreak("md_dn");
  const [face, setFace] = useState("");
  const handleStatusPopup = useCallback(() => {
    setState((prev) => !prev);
  }, []);

  const animation = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.5, ease: "linear" },
  };
  const multiActive = useAtom(isMulti_project_active)[0];
  const hideTooltip = useCallback(() => {
    const tooltip = document.getElementById("tooltip");
    if (tooltip) tooltip.style.display = "none";
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const showTooltip = useCallback(
    (evt) => {
      const coords = 0;
      const tooltip = document.getElementById("tooltip");
      if (!tooltip) return;
      tooltip.style.display = "flex";
      tooltip.style.left = `${evt.clientX + coords}px`;
      tooltip.style.top = `${evt.clientY + coords}px`;

      if (isMobile) {
        if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(() => {
          hideTooltip();
        }, 10000);
      }
    },
    [hideTooltip, isMobile],
  );
  // const routeChecks = useMemo(() => {
  //   const checks = {
  //     atModel: here.includes("isometry"),
  //     atList: here.includes("list"),
  //     atFavorites: here.includes("favorites"),
  //     atUnit: here.includes("unit"),
  //     atCompare: here.includes("compare"),
  //     atDownloads: here.includes("downloads"),
  //     atGallery: here.includes("gallery"),
  //   };

  //   checks.hidePropertyDropdownAtDesktop = ["unit", "downloads"].some((i) =>
  //     here.includes(i),
  //   );

  //   checks.hideFilterMultiActiveTrue = [
  //     "isometry",
  //     "compare",
  //     "gallery",
  //     "downloads",
  //     "unit",
  //   ].some((i) => here.includes(i));

  //   checks.hideFilterMultiActiveFalse = [
  //     "compare",
  //     "gallery",
  //     "downloads",
  //     "unit",
  //   ].some((i) => here.includes(i));

  //   checks.filterShouldShow = !multiActive
  //     ? !checks.hideFilterMultiActiveTrue
  //     : !checks.hideFilterMultiActiveFalse;

  //   return checks;
  // }, [here, multiActive]);
  useEffect(() => {
    return () => {
      if (timeoutRef.current) window.clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (Object.keys(dropdownOptions).length && pid) {
      const selectedProject = dropdownOptions[currentLanguage]
        .filter((d, i) => d.PID === pid && i === pin)[0];
      setFace(selectedProject?.Presentation || "");
    }
  }, [pid, pin, currentLanguage, dropdownOptions]);

  const hasLowConfig = Boolean(
    lowIsoData.config && Object.keys(lowIsoData.config).length,
  );
  const useViewMap =
    hasLowConfig && lowIsoData.config.IMAGE_SNAPFRAMES?.length === 1;
  const showIsometry =
    hasLowConfig && pid && pin >= 0 && !Array.isArray(isoData.frame);

  if (useViewMap)
    return <ViewMap showTooltip={showTooltip} hideTooltip={hideTooltip} />;

  if (showIsometry)
    return (
      <>
        {/* button to open openhouse event info */}
        {/* <OpenHouseEventInfoPopup /> */}
        {/* button to open openhouse event info */}
        <AnimatePresence>
          <Tooltip
            id="tooltip"
            as={motion.div}
            {...animation}
            className="paragraph1-regular"
          >
            Kommer snart
          </Tooltip>
        </AnimatePresence>
        <Cursor>
          { <OverviewBack /> }
         
        
          
        {iFrameEnabled && isDesktop  &&
        
        <CurrentViewText> <span className="h4">Du kigger lige nu på:</span> &nbsp;{face} </CurrentViewText>
        
        }
          <SnapOnRotationEnd
            {...{
              frame: isoData.frame,
              setFrame,
              config: isoData.config,
              setIndex,
              rmode,
              isrotate,
              index: isoData.index,
            }}
          />
          <Measure ref={measure}>
            <ZoomPanPinch {...{ ref: zppRef, ...zppsetup }}>
              {isoData.status !== "DONE" ? (
                <>
                  <Tiny
                    {...{
                      frames: lowIsoData.frames,
                      frame: isoData.frame,
                      tiny: isoData.tiny,
                      dim,
                      status: lowIsoData.status,
                      percent: lowIsoData.percent,
                    }}
                  />
                  <Canvas
                    {...{
                      ref: canRef,
                      frame: isoData.frame,
                      pin,
                      pid,
                      status: lowIsoData.status,
                      dim,
                      frames: lowIsoData.frames,
                      config: lowIsoData.config,
                    }}
                  />
                </>
              ) : (
                <>
                  <Tiny
                    {...{
                      frames: isoData.frames,
                      frame: isoData.frame,
                      tiny: isoData.tiny,
                      dim,
                      status: isoData.status,
                      percent: isoData.percent,
                    }}
                  />
                  <Canvas
                    {...{
                      ref: canRef,
                      frame: isoData.frame,
                      pin,
                      pid,
                      status: isoData.status,
                      dim,
                      frames: isoData.frames,
                      config: isoData.config,
                    }}
                  />
                </>
              )}
              <Center {...{ point }} />
              {!rmode && (
                <Svg
                  {...{
                    svg: isoData.svg,
                    percent: lowIsoData.percent,
                    units,
                    showTooltip,
                    hideTooltip,
                  }}
                />
              )}
              {/* <Labels {...{ frame: isoData.frame, index: isoData.index, config: isoData.config, rmode, scale }}/> */}
              {/* <Overview {...{ frame: isoData.frame, index: isoData.index, config: isoData.config, rmode, status: isoData.status }}/> */}
            </ZoomPanPinch>
          </Measure>
          {/* <Space d = {pin === 0 ? 0 : 76} m = {0} /> */}
          <Loading2
            {...{
              progress: lowIsoData.percent,
              show: lowIsoData.status !== "DONE" || !Boolean(raw?.length),
            }}
          />
          <AnimatePresence>
            {lowIsoData.percent == 100 && showOldSlider ? (
              <OldSnapSlider
                {...{
                  frame: isoData.frame,
                  setFrame,
                  config: lowIsoData.config,
                  frames: lowIsoData.frames,
                  index: isoData.index,
                  setIndex,
                }}
              />
            ) : (
              <>
                {rmode && (
                  <>
                    <NoSnapSlider
                      {...{
                        frame: isoData.frame,
                        setFrame,
                        config: lowIsoData.config,
                        frames: lowIsoData.frames,
                        index: isoData.index,
                        setIndex,
                      }}
                    />
                    {isrotate && (
                      <Play
                        {...{
                          frame: isoData.frame,
                          setFrame,
                          config: lowIsoData.config,
                          setIndex,
                        }}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </AnimatePresence>
          <FloatBtn
            rmode={rmode}
            projectType={projectType}
            pin={pin}
            iFrameEnabled={iFrameEnabled}
          >
            <Recenter
              rmode={rmode}
              z={zppRef}
              bounds={bounds}
              dim={dim}
              pin={pin}
              {...{ percent: lowIsoData.percent }}
            />
            <Compas
              frame={isoData.frame}
              cfg={lowIsoData.config}
              label={
                buttonsLabel?.filter(
                  (btn) => btn.UILabelProperty === "Nordpil",
                )[0]?.Label
              }
              {...{ percent: lowIsoData.percent }}
            />
          </FloatBtn>

          {state && pin >= 1 && !rmode && (
            <>
              <DesktopColorLegend />
            </>
          )}

          <StatusButton rmode={rmode} projectType={projectType} pin={pin}>
            {isMobile && pin >= 1 && lowIsoData.percent == 100 && !rmode && (
              <Box
                onClick={handleStatusPopup}
                component="img"
                src={statusIconPath}
              />
            )}
          </StatusButton>
        </Cursor>
      </>
    );
};

const StatusButton = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  ${BREAK_.md_dn} {
  
    left: 16px;
    bottom: 82px;
    padding-right: 8px;
    cursor: pointer;
  }
`;
export const CurrentViewText = styled.div`
  position: absolute;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 99;

  display: flex;
  align-items: center;

  background-color: #ffffffbf;
  padding: 8px;
  border-radius: 6px;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;

  width: max-content;
`;

const FloatBtn = styled.div`
  position: absolute;
  top: 28px;
  right: ${({ rmode }) => (rmode ? 42 : 42)}px;
  display: flex;
  gap: 8px;

  ${BREAK_.md_dn} {
    top: ${({ rmode, pin, projectType, iFrameEnabled }) =>
      (pin > 0 || projectType === "mono") && rmode
        ? "17px"
        : iFrameEnabled
        ? "24px"
        : pin > 0 || projectType === "mono"
        ? "86px"
        : "24px"};
    right: 18px;
  }
`;

const Tooltip = styled(motion.div)`
  display: none;
  height: 39px;
  border-radius: 8px;
  border: 1px solid ${({ clr }) => clr?.primary ?? "transparent"};
  background: ${({ clr }) => `${clr?.primary ?? "#000"}db`};
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  position: fixed;
  color: #fff;
  z-index: 1;
`;
